import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Core.ContractConsent.GetDocumentsPublic.IParams;
type Response = Api.Core.ContractConsent.GetDocumentsPublic.IResponse;
type Headers = Api.Core.ContractConsent.GetDocumentsPublic.IHeaders;
const url = '/api/Public/GetContractConsentDocuments/:contractConsentId';
export default async function getContractConsentDocumentsPublicApi({
  params,
  access_token,
}: {
  params: Params;
  access_token: string;
}): Promise<Api.Res<Response>> {
  return await executeServerApi<Params, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params, null),
    headers: { ...getDefaultHeaders(), Authorization: `Bearer ${access_token}` },
  });
}
